import React from 'react';

const API_URL = '';

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen bg-[#FCFBF9]">
      <div className="max-w-3xl mx-auto px-4 py-16">
        <h1 className="text-3xl font-serif font-bold mb-8" data-testid="mentions-title">Mentions Legales</h1>

        <div className="space-y-8 text-sm text-[#3A3938] leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold mb-3">Editeur du site</h2>
            <p>Bloom Lingerie</p>
            <p>Site web : bloom-lingerie.com</p>
            <p>Email : bloom.lingerie.store@gmail.com</p>
            <p>Activite : Vente en ligne de lingerie et prets-a-porter feminin</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">Hebergement</h2>
            <p>Le site est heberge par Emergent Labs.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">Propriete intellectuelle</h2>
            <p>L'ensemble du contenu du site bloom-lingerie.com (textes, images, logos, elements graphiques) est protege par le droit d'auteur. Toute reproduction, meme partielle, est interdite sans autorisation prealable ecrite de Bloom Lingerie.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">Donnees personnelles</h2>
            <p>Les donnees personnelles collectees sur ce site sont traitees conformement a la legislation algerienne en vigueur relative a la protection des donnees personnelles. Vous disposez d'un droit d'acces, de rectification et de suppression de vos donnees en nous contactant par email.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">Cookies</h2>
            <p>Le site utilise des cookies techniques necessaires a son fonctionnement (session, panier, preferences). Aucun cookie publicitaire ou de tracking tiers n'est utilise sans votre consentement.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">Limitation de responsabilite</h2>
            <p>Bloom Lingerie s'efforce de maintenir les informations du site a jour. Toutefois, elle ne peut garantir l'exactitude, la completude ou l'actualite des informations diffusees. L'utilisation du site se fait sous la responsabilite de l'utilisateur.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold mb-3">Droit applicable</h2>
            <p>Les presentes mentions legales sont regies par le droit algerien. Tout litige relatif a l'utilisation du site sera soumis aux tribunaux competents d'Algerie.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
